const MuiCssBaseline = (theme) => ({
  MuiCssBaseline: {
    styleOverrides: `
      *, *::before, *::after {
        box-sizing: border-box;
      }

      html {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        scroll-behavior: smooth;
        text-rendering: optimizeLegibility;
      }

      body {
        margin: 0;
        padding: 0;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        background: ${theme.palette.background.default};
        color: ${theme.palette.text.primary};
        overflow-x: hidden;
        transition: background-color 0.3s ease, color 0.3s ease;
      }

      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      ::-webkit-scrollbar-track {
        background: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)'};
        border-radius: 100px;
      }
      ::-webkit-scrollbar-thumb {
        background: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)'};
        border-radius: 100px;
        border: 2px solid transparent;
        background-clip: content-box;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.25)'};
        border-radius: 100px;
        border: 2px solid transparent;
        background-clip: content-box;
      }

      a {
        color: inherit;
        text-decoration: none;
      }

      img {
        max-width: 100%;
        display: block;
      }

      ::selection {
        background: ${theme.palette.primary.main};
        color: #fff;
      }
    `,
  },
})

export default MuiCssBaseline
